module.exports = __webpack_public_path__ + "img/banner_left.6de594c0.png";